import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CsrfService } from '../services/csrf.service';

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {

  constructor(private csrfService: CsrfService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Solo agregar CSRF token en métodos mutantes
    const mutatingMethods = ['POST', 'PUT', 'DELETE', 'PATCH'];
    
    if (!mutatingMethods.includes(request.method)) {
      return next.handle(request);
    }

    // Excluir login, portal cliente y endpoints públicos
    if (request.url.includes('/common/auth/login') ||
        request.url.includes('/portalclient/') ||
        request.url.includes('/health') ||
        request.url.includes('/public/')) {
      return next.handle(request);
    }

    // Agregar token CSRF si existe
    const csrfToken = this.csrfService.getToken();
    if (csrfToken) {
      request = request.clone({
        setHeaders: {
          'X-CSRF-Token': csrfToken
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Si el error es por CSRF inválido, intentar renovar token
        if (error.status === 403 && 
            error.error?.error?.message?.includes('CSRF')) {
          console.warn('CSRF token invalid, needs renewal');
          this.csrfService.clearToken();
        }
        return throwError(error);
      })
    );
  }
}
